<section class="dashboard-body-section">
    <router-outlet></router-outlet>
</section>
<app-landing-page-header></app-landing-page-header>